import { styled, component } from '../../utils/style';

export const StaticPageIframe = styled()(component.iframe, 'StaticPageIframe') `
	width: 100%;
	height: 100%;
	border: none;
	vertical-align: top;
`;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/StaticPage/styles.ts